import { render, staticRenderFns } from "./HistoryPagination.vue?vue&type=template&id=6d266f17&"
import script from "./HistoryPagination.vue?vue&type=script&lang=ts&"
export * from "./HistoryPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports